require('./fix-jquery.js');
require('./color-picker/colors.js');
require('./color-picker/colorPicker.data.js');
require('./color-picker/colorPicker.js');
require('./color-picker/jqColor.js');

require('./ng-vue.js');
require('./ng-file-upload.js');
require('./dropzone.js');
require('./ng-flow-standalone.min.js');
import 'fabric';

//require('./fabric/fabric.min.js');
require('./fabric/fabric.object.js');
require('./fabric/perspective_filter.class.js');
require('./fabric/fabric.control.js');
require('./fabric/fabric.rotationControl.js');
require('./fabric/fabric.align.js');
require('./fabric/fabric.drag.js');
require('./fabric/fabric.palette.js');
require('./fabric/fabric.util.js');
require('./fabric/fabric.canvasex.js');
require('./fabric/activeSelection.js');

require('./angular-aside.min.js');
require('./angular-avatar.js');
require('./async-pool.js');
require('./ui-bootstrap-tpls-0.14.3.min.js');
require('./block-ui/angular-block-ui');

require('./ImagePlaceholder/fabricImagePlaceholder');
require('./BoundedText/BoundedText');
require('./BoundedText/TextPathEditor');
require('./BoundedText/TextPathPen');
require('./BoundedText/TextShapeEditor');
require('./BoundedText/PathText/PathIText');
require('./TextTransform');
require('./VectorPlaceholder/fabricPDFObject');
require('./VectorPlaceholder/fabricSVGObject');
require('./VectorPlaceholder/fabricVectorPlaceholder');

require('./fabric/fabric.perspective.js');
